module.exports = __webpack_public_path__ + "assets/img/icon3.23f26792.png";